const getJobTypeList = ({ page, ...restData }) => ({
  method: "GET",
  url: "/job_types",
  data: { ...restData },
});

export const jobTypesApi = {
  getJobTypeList,
};
